import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';

import Header from '../Example/components/Header';
import Copyright from '../../components/Copyright';
import CustomTab from '../../CustomTab';

import { AppContext, useApp } from '../../contexts/AppContext';

import "./styles.scss"
import TicketsList from '../../components/TicketsList';
import TicketsCard from '../../components/TicketCard';
import { startLoading, stopLoading } from '../../services/common-service';
import api from '../../factory/api';
import TicketComment from './components/TicketComment';
import TicketResume from './components/TicketResume';
import Hr from '../../components/Hr';
import Input from '../../components/Input/Input';
import FieldItem from '../../components/ModalItem/FieldItem';
import TicketNewComment from './components/TicketNewComment';

const PAGE_ICON = 'ticket';
const BLANK = '_blank';

const Ticket = () => {
    const { t, i18n, appInfo } = useContext(AppContext)
    const { ticketId } = useParams()

    const history = useHistory();
    const { state } = useLocation();
    const { config } = useApp()

    const [customTab, setCustomTab] = useState(null)

    const [isLoading, setIsLoading] = useState(false)

    const [ticket, setTicket] = useState()

    const all = useParams()

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        start()
    }, [])

    const start = async () => {
        try {
            startLoading()
            setIsLoading(() => true)

            let { data } = await api.get(`/tickets/${ticketId}`, {
                headers: {
                    tenantId: appInfo.tenantId
                }
            })

            let { ticket } = data

            setTicket(ticket)
        } catch (error) {

        } finally {
            stopLoading()
            setIsLoading(() => false)
        }
    }

    return (
        <div className="flex" style={{ height: "100vh", overflowX: "auto" }}>
            <div className="home-container ph1 ph4-m ph5-ns pb5 relative" style={{ flex: 1 }}>
                <Header title={t('menu.goBack')} onClick={() => history.push('/')} />

                {ticket &&
                    <>
                        <div style={{ marginTop: 20, marginBottom: 20 }}>
                            <TicketsCard
                                ticket={ticket}
                                clickable={false}
                            />
                        </div>

                        <div className="flex flex-column" style={{ gap: 20 }}>
                            <TicketResume
                                ticket={ticket}
                            />

                            {ticket?.comments?.map((comment, index) =>
                                <div key={comment.id}>
                                    <TicketComment
                                        comment={comment}
                                    />
                                </div>
                            )}

                            <Hr />

                            {/* {JSON.stringify(data)} */}

                            {ticket?.status == "finished" ?
                                <div className="center">
                                    <bds-typo variant="fs-20" bold="light" margin={false}>Chamado finalizado</bds-typo>
                                </div> :
                                <TicketNewComment
                                    ticket={ticket}
                                    reload={start}
                                />
                            }
                        </div>
                    </>
                }

                {/* {(!ticketOpened || (ticketOpened && config?.showCopyrightWithTicketOpen)) &&
                    <Copyright />
                } */}
            </div>

            <CustomTab
                opened={customTab != null}
                setCustomTab={setCustomTab}
                {...customTab}
            />
        </div>
    );
};

Ticket.propTypes = {};

export default Ticket;
